import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./projects.css";

const projects = [
  {
    title: "AI AutoQuery",
    stack: [
      "Open AI",
      "Node.js",
      "Express",
      "React",
      "MySQL",
      "MongoDB",
      "Docker",
      "JWT",
    ],
    duration: " Jan 2026 – Present",
    desc: `Built AI-based query system transforming natural language to database queries. Supports MySQL, SQL Server, MongoDB. Includes Dockerized deployment and secure authentication.`,
  },
  {
    title: "OTT Platform - Chanajor",
    stack: ["Node.js", "Express", "React", "MySQL", "FFMPEG", "AWS S3"],
    duration: "Mar 2024 – Sep 2025",
    desc: `Developed secure video platform with AES-encrypted HLS, custom CMS, API integrations, multi-gateway billing, and full subscription lifecycle management.`,
  },
  {
    title: "OTT Platform - MyToonz",
    stack: ["Node.js", "Express", "React", "MySQL"],
    duration: "Jul 2021 – Feb 2023",
    desc: `Built a full-stack OTT platform for media content streaming, including CMS, subscriptions, user auth, and trial flow.`,
  },
  {
    title: "Vuclip Videos VAS (PAAS)",
    stack: ["PHP", "MySQL", "RabbitMQ", "CMS", "UIKIT"],
    duration: "May 2020 – Jul 2021",
    desc: `Created a video content VAS platform integrated with telecom billing for subscription handling, SMS/USSD, and partner reporting.`,
  },
  {
    title: "Vuclip Games VAS (PAAS)",
    stack: ["PHP", "MySQL", "RabbitMQ", "CMS", "UIKIT"],
    duration: "Nov 2018 – Apr 2020",
    desc: `Developed mobile gaming delivery system with dynamic content management, game previews, and optimized gameplay UX.`,
  },
  {
    title: "Operator Billing System (BAAS)",
    stack: ["PHP", "MySQL", "CMS", "UIKIT"],
    duration: "Oct 2017 – Oct 2018",
    desc: `Built a billing system enabling third-party providers to use telecom billing APIs. Managed subscription logic and fraud prevention.`,
  },
  {
    title: "AdTrack System",
    stack: ["PHP", "MySQL", "JavaScript", "HTML/CSS"],
    duration: "Aug 2016 – Sep 2017",
    desc: `Built an ad postback and tracking system with configurable logic and campaign-wise reporting dashboard.`,
  },
];

const Projects = () => (
  <section id="projects" >
    <Container>
      <h2 className="mb-4">Key Projects</h2>
      <Row>
        {projects.map((project, i) => (
          <Col md={12} lg={12} key={i} className="mb-4">
            <Card className="project-card h-100">
              <Card.Body>
                <Card.Title className="fw-bold">{project.title}</Card.Title>
                <Card.Subtitle className="mb-2 text-muted">
                  {/* <small>{project.duration}</small> */}
                </Card.Subtitle>
                <Card.Text className="mt-3">{project.desc}</Card.Text>
                <div className="mt-3">
                  {project.stack.map((tech, index) => (
                    <span key={index} className="project-badge">
  {tech}
</span>
                  ))}
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  </section>
);

export default Projects;
